/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Upload_Online_OnlyInputs */

const en_audio_recorder_upload_online_only = /** @type {(inputs: Audio_Recorder_Upload_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recording upload is only available in online mode.`)
};

const fr_audio_recorder_upload_online_only = /** @type {(inputs: Audio_Recorder_Upload_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le téléversement de l'enregistrement est disponible uniquement en mode en ligne.`)
};

const de_audio_recorder_upload_online_only = /** @type {(inputs: Audio_Recorder_Upload_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Hochladen von Aufnahmen ist nur im Online-Modus möglich.`)
};

const it_audio_recorder_upload_online_only = /** @type {(inputs: Audio_Recorder_Upload_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il caricamento delle registrazioni è disponibile solo in modalità online.`)
};

const ru_audio_recorder_upload_online_only = /** @type {(inputs: Audio_Recorder_Upload_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка записи доступна только в онлайн-режиме.`)
};

const es_audio_recorder_upload_online_only = /** @type {(inputs: Audio_Recorder_Upload_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La carga de grabaciones solo está disponible en modo en línea.`)
};

const zh_cn2_audio_recorder_upload_online_only = /** @type {(inputs: Audio_Recorder_Upload_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`录像上传仅支持在线模式。`)
};

const ja_audio_recorder_upload_online_only = /** @type {(inputs: Audio_Recorder_Upload_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`録画のアップロードはオンライン モードでのみ利用できます。`)
};

const hi_audio_recorder_upload_online_only = /** @type {(inputs: Audio_Recorder_Upload_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्डिंग अपलोड करने की सुविधा केवल ऑनलाइन मोड में ही उपलब्ध है।`)
};

const pt_pt2_audio_recorder_upload_online_only = /** @type {(inputs: Audio_Recorder_Upload_Online_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O envio de gravações só está disponível no modo online.`)
};

/**
* | output |
* | --- |
* | "Recording upload is only available in online mode." |
*
* @param {Audio_Recorder_Upload_Online_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_upload_online_only = /** @type {((inputs?: Audio_Recorder_Upload_Online_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Upload_Online_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_upload_online_only(inputs)
	if (locale === "de") return de_audio_recorder_upload_online_only(inputs)
	if (locale === "it") return it_audio_recorder_upload_online_only(inputs)
	if (locale === "ru") return ru_audio_recorder_upload_online_only(inputs)
	if (locale === "es") return es_audio_recorder_upload_online_only(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_upload_online_only(inputs)
	if (locale === "ja") return ja_audio_recorder_upload_online_only(inputs)
	if (locale === "hi") return hi_audio_recorder_upload_online_only(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_upload_online_only(inputs)
	return en_audio_recorder_upload_online_only(inputs)
});